import { useEffect, useState } from "react";
import { io } from "socket.io-client";


export const useSocket = (serverUrl) => {
    const [socket, setSocket] = useState(null);
  
    useEffect(() => {
      const socketIo = io(serverUrl);
  
      setSocket(socketIo);
  
      // Cleanup on unmount
      return () => {
        socketIo.disconnect();
      };
    }, [serverUrl]);
  
    return socket;
  };